import { FC, useMemo } from 'react';
import {
    StyledCard,
    PropertyDetailsContainer,
    StyledPropertyPriceSmall,
    StyledPropertyAddressLarge,
    FeaturePropertyCardWrapper
} from '../FeaturedProperties.styles';
import { InternalPromoData } from './internalPromoData';
import {
    CTAWrapper,
    PromoCardImage,
    PromoCardDetails
} from './InternalPromoCard.styles';
import { Button, CardImage, Link } from '@blueprint/ui';

export type Props = {
    promo: InternalPromoData;
    currentSection: 'for-sale' | 'to-rent';
    searchParam?: string;
    onClick?: () => void;
};

const usePromoLink = ({ promo, currentSection, searchParam }: Props) =>
    useMemo(() => {
        if (promo.name === 'smartmap') {
            return `${currentSection}/${promo.link}/${
                searchParam ? searchParam : ''
            }`;
        } else if (promo.name === 'newhomes' && searchParam) {
            return `${promo.link}/${searchParam}`;
        }

        return promo.link;
    }, [promo, currentSection, searchParam]);

const InternalPromoCard: FC<React.PropsWithChildren<Props>> = (props) => {
    const { promo, onClick } = props;

    const link = usePromoLink(props);

    return (
        <FeaturePropertyCardWrapper>
            <Link
                plain
                href={`/${link}`}
                data-testid="featured-promo"
                onClick={onClick}
                {...props}
            >
                <StyledCard
                    hasShadow={false}
                    hasBorder={false}
                    hasBackground
                    contentAlignment="center"
                >
                    <PromoCardImage>
                        <CardImage
                            src={promo.image.src}
                            responsiveImgList={promo.image.responsiveImgList}
                        />
                    </PromoCardImage>
                    <PropertyDetailsContainer>
                        <PromoCardDetails>
                            <StyledPropertyPriceSmall>
                                {promo.title}
                            </StyledPropertyPriceSmall>
                            <StyledPropertyAddressLarge>
                                {promo.details}
                            </StyledPropertyAddressLarge>
                        </PromoCardDetails>
                        <CTAWrapper>
                            <Button variant="secondary" isFullWidth>
                                {promo.cta}
                            </Button>
                        </CTAWrapper>
                    </PropertyDetailsContainer>
                </StyledCard>
            </Link>
        </FeaturePropertyCardWrapper>
    );
};

export default InternalPromoCard;
